<template>
  <div class="unused-privilege">
    <div class="privilege-header">
      <img src="./images/logo_font2@2x.png" alt="" class="header-logo">
      <div class="header-home" @click="jumpHome">去主页</div>
    </div>
    <div class="privilege-tips"></div>
    <div class="privilege-content">
      <div class="content-title">
        {{flow === 'credit' ? '您有机会获得最高额度' : '可用额度（元）'}}
      </div>
      <div class="content-amount">{{formatMoney(amount)}}</div>
      <div class="content-rate">审批快 综合年化利率15.4%起（单利计算）</div>
      <div class="content-button" @click="jumpRetrial" >重新审核</div>
    </div>
  </div>
</template>

<script>
// 未使用重审卡的展示，支持授信和提现页面
import { mapActions } from 'vuex'

export default {
  name: 'UnusedPrivilege',
  props: {
    flow: {
      type: String,
      default: 'credit' // credit: 授信， loan: 提现
    },
    amount: {
      type: [Number, String],
      default: 50000
    },
    retryCouponSerialId: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions('authentication', [
      'reAuditX'
    ]),
    jumpHome () {
      this.$router.push('/river/diversion')
    },
    // 跳转重新审核
    async jumpRetrial () {
      if (!this.retryCouponSerialId) {
        this.$message('未找到券ID')
        return
      }
      if (this.flow === 'credit') {
        const { success, msg } = await this.reAuditX({
          couponSerialId: this.retryCouponSerialId
        })
        if (success) {
          this.$router.replace(`/authentication/auditing?applyNo=${this.$route.query.applyNo}&status=credit`)
        } else {
          this.$message(msg)
        }
      } else if (this.flow === 'loan') {
        this.$router.push({
          path: '/withdraw/index2',
          query: {
            couponSerialId: this.retryCouponSerialId
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.unused-privilege{
  padding: 50px 40px;
  padding-top: 0;
  .privilege-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-logo{
      width: 189px;
      height: 60px;
    }
    .header-home{
      font-size: 28px;
      color: #666666;
      text-decoration: underline;
    }
  }
  .privilege-tips{
    font-size: 28px;
    color: #333333;
    margin-top: 9px;
    line-height: 40px;
  }
  .privilege-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 10px 40px 0px rgba(211, 211, 211, 0.5);
    background-color: #fff;
    border-radius: 20px;
    margin-top: 32px;
    padding: 66px 0 40px;
    color: #333333;
    .content-title{
      font-size: 28px;
      line-height: 40px;
    }
    .content-amount{
      font-family: DIN-Medium, DIN;
      font-size: 100px;
      line-height: 121px;
    }
    .content-rate{
      font-size: 24px;
      color: #999999;
      margin-top: 44px;
    }
    .content-button{
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      width: 460px;
      height: 88px;
      line-height: 88px;
      text-align: center;
      border-radius: 47px;
      color: #fff;
      font-size: 32px;
      font-weight: bold;
      margin-top: 28px;
      animation: btnScale 1s linear infinite;
    }
  }
}
</style>